// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CarDimensionsRouteImport } from './routes/car-dimensions'
import { Route as CarMaintenanceScheduleRouteImport } from './routes/car-maintenance-schedule'
import { Route as CarSafetyRatingsRouteImport } from './routes/car-safety-ratings'
import { Route as CarSizeComparisonRouteImport } from './routes/car-size-comparison'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FuelTankCapacityRouteImport } from './routes/fuel-tank-capacity'
import { Route as HowMuchCanMyCarTowRouteImport } from './routes/how-much-can-my-car-tow'
import { Route as MaintenanceComparisonRouteImport } from './routes/maintenance-comparison'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as MpgComparisonRouteImport } from './routes/mpg-comparison'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TowingCapacityRouteImport } from './routes/towing-capacity'
import { Route as TransmissionFluidChangeIntervalRouteImport } from './routes/transmission-fluid-change-interval'
import { Route as TruckBedDimensionsRouteImport } from './routes/truck-bed-dimensions'
import { Route as VinDecoderRouteImport } from './routes/vin-decoder'
import { Route as MakeIndexRouteImport } from './routes/$make.index'
import { Route as MakeMaintenanceScheduleRouteImport } from './routes/$make.maintenance-schedule'
import { Route as AdminGithubHelpRouteImport } from './routes/admin.github-help'
import { Route as AdminIndexingRouteImport } from './routes/admin.indexing'
import { Route as AdminSearchConsoleRouteImport } from './routes/admin.search-console'
import { Route as AdminSeoRouteImport } from './routes/admin.seo'
import { Route as BestIndexRouteImport } from './routes/best.index'
import { Route as BestSlugRouteImport } from './routes/best.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as ComparePairRouteImport } from './routes/compare.$pair'
import { Route as ReportsTruckStatsRouteImport } from './routes/reports/truck-stats'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as MakeModelIndexRouteImport } from './routes/$make.$model.index'
import { Route as MakeModelDataTypeRouteImport } from './routes/$make.$model.$dataType'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CarDimensionsRoute = CarDimensionsRouteImport.update({
            id: '/car-dimensions',path: '/car-dimensions',getParentRoute: () => rootRouteImport
          })
const CarMaintenanceScheduleRoute = CarMaintenanceScheduleRouteImport.update({
            id: '/car-maintenance-schedule',path: '/car-maintenance-schedule',getParentRoute: () => rootRouteImport
          })
const CarSafetyRatingsRoute = CarSafetyRatingsRouteImport.update({
            id: '/car-safety-ratings',path: '/car-safety-ratings',getParentRoute: () => rootRouteImport
          })
const CarSizeComparisonRoute = CarSizeComparisonRouteImport.update({
            id: '/car-size-comparison',path: '/car-size-comparison',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FuelTankCapacityRoute = FuelTankCapacityRouteImport.update({
            id: '/fuel-tank-capacity',path: '/fuel-tank-capacity',getParentRoute: () => rootRouteImport
          })
const HowMuchCanMyCarTowRoute = HowMuchCanMyCarTowRouteImport.update({
            id: '/how-much-can-my-car-tow',path: '/how-much-can-my-car-tow',getParentRoute: () => rootRouteImport
          })
const MaintenanceComparisonRoute = MaintenanceComparisonRouteImport.update({
            id: '/maintenance-comparison',path: '/maintenance-comparison',getParentRoute: () => rootRouteImport
          })
const MethodologyRoute = MethodologyRouteImport.update({
            id: '/methodology',path: '/methodology',getParentRoute: () => rootRouteImport
          })
const MpgComparisonRoute = MpgComparisonRouteImport.update({
            id: '/mpg-comparison',path: '/mpg-comparison',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TowingCapacityRoute = TowingCapacityRouteImport.update({
            id: '/towing-capacity',path: '/towing-capacity',getParentRoute: () => rootRouteImport
          })
const TransmissionFluidChangeIntervalRoute = TransmissionFluidChangeIntervalRouteImport.update({
            id: '/transmission-fluid-change-interval',path: '/transmission-fluid-change-interval',getParentRoute: () => rootRouteImport
          })
const TruckBedDimensionsRoute = TruckBedDimensionsRouteImport.update({
            id: '/truck-bed-dimensions',path: '/truck-bed-dimensions',getParentRoute: () => rootRouteImport
          })
const VinDecoderRoute = VinDecoderRouteImport.update({
            id: '/vin-decoder',path: '/vin-decoder',getParentRoute: () => rootRouteImport
          })
const MakeIndexRoute = MakeIndexRouteImport.update({
            id: '/$make/',path: '/$make/',getParentRoute: () => rootRouteImport
          })
const MakeMaintenanceScheduleRoute = MakeMaintenanceScheduleRouteImport.update({
            id: '/$make/maintenance-schedule',path: '/$make/maintenance-schedule',getParentRoute: () => rootRouteImport
          })
const AdminGithubHelpRoute = AdminGithubHelpRouteImport.update({
            id: '/admin/github-help',path: '/admin/github-help',getParentRoute: () => rootRouteImport
          })
const AdminIndexingRoute = AdminIndexingRouteImport.update({
            id: '/admin/indexing',path: '/admin/indexing',getParentRoute: () => rootRouteImport
          })
const AdminSearchConsoleRoute = AdminSearchConsoleRouteImport.update({
            id: '/admin/search-console',path: '/admin/search-console',getParentRoute: () => rootRouteImport
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/admin/seo',path: '/admin/seo',getParentRoute: () => rootRouteImport
          })
const BestIndexRoute = BestIndexRouteImport.update({
            id: '/best/',path: '/best/',getParentRoute: () => rootRouteImport
          })
const BestSlugRoute = BestSlugRouteImport.update({
            id: '/best/$slug',path: '/best/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const ComparePairRoute = ComparePairRouteImport.update({
            id: '/compare/$pair',path: '/compare/$pair',getParentRoute: () => rootRouteImport
          })
const ReportsTruckStatsRoute = ReportsTruckStatsRouteImport.update({
            id: '/reports/truck-stats',path: '/reports/truck-stats',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/tools/$slug',path: '/tools/$slug',getParentRoute: () => rootRouteImport
          })
const MakeModelIndexRoute = MakeModelIndexRouteImport.update({
            id: '/$make/$model/',path: '/$make/$model/',getParentRoute: () => rootRouteImport
          })
const MakeModelDataTypeRoute = MakeModelDataTypeRouteImport.update({
            id: '/$make/$model/$dataType',path: '/$make/$model/$dataType',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CarDimensionsRoute: CarDimensionsRoute,CarMaintenanceScheduleRoute: CarMaintenanceScheduleRoute,CarSafetyRatingsRoute: CarSafetyRatingsRoute,CarSizeComparisonRoute: CarSizeComparisonRoute,ContactRoute: ContactRoute,FuelTankCapacityRoute: FuelTankCapacityRoute,HowMuchCanMyCarTowRoute: HowMuchCanMyCarTowRoute,MaintenanceComparisonRoute: MaintenanceComparisonRoute,MethodologyRoute: MethodologyRoute,MpgComparisonRoute: MpgComparisonRoute,PrivacyRoute: PrivacyRoute,SearchRoute: SearchRoute,TermsRoute: TermsRoute,TowingCapacityRoute: TowingCapacityRoute,TransmissionFluidChangeIntervalRoute: TransmissionFluidChangeIntervalRoute,TruckBedDimensionsRoute: TruckBedDimensionsRoute,VinDecoderRoute: VinDecoderRoute,MakeMaintenanceScheduleRoute: MakeMaintenanceScheduleRoute,AdminGithubHelpRoute: AdminGithubHelpRoute,AdminIndexingRoute: AdminIndexingRoute,AdminSearchConsoleRoute: AdminSearchConsoleRoute,AdminSeoRoute: AdminSeoRoute,BestSlugRoute: BestSlugRoute,BlogSlugRoute: BlogSlugRoute,ComparePairRoute: ComparePairRoute,ReportsTruckStatsRoute: ReportsTruckStatsRoute,ToolsSlugRoute: ToolsSlugRoute,MakeIndexRoute: MakeIndexRoute,BestIndexRoute: BestIndexRoute,BlogIndexRoute: BlogIndexRoute,CompareIndexRoute: CompareIndexRoute,ToolsIndexRoute: ToolsIndexRoute,MakeModelDataTypeRoute: MakeModelDataTypeRoute,MakeModelIndexRoute: MakeModelIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)